
import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-luijten-gray">
      <div className="text-center p-8 max-w-md">
        <AlertTriangle className="h-16 w-16 mx-auto mb-6 text-luijten-blue" />
        <h1 className="text-4xl font-bold mb-4 text-luijten-blue">404</h1>
        <p className="text-xl text-gray-600 mb-6">Pagina niet gevonden</p>
        <p className="text-gray-500 mb-8">
          De pagina die u probeert te bezoeken bestaat niet of is verplaatst.
        </p>
        <Button asChild>
          <Link to="/">Terug naar Dashboard</Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
